<section class="content-layout content-layout-6">
  <div class="container">
    @if (breakpoints() === "mobile") {
      <div class="row">
        <div class="col-xs-12">
          @if (subtitle()) {
            <app-title [titles]="[subtitle()]" />
          }
          @if (title()) {
            <app-title [titles]="[title()]" class="title" />
          }
          @if (data().html; as html) {
            <div [innerHTML]="html" class="paragraph"></div>
          }
        </div>
      </div>
    } @else {
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-7">
              @if (title()) {
                <app-title [titles]="[title()]" class="title" />
              }
            </div>
            <div class="col-lg-7"></div>
          </div>
          <div class="row">
            <div class="col-lg-5">
              @if (subtitle()) {
                <app-title [titles]="[subtitle()]" />
              }
            </div>
            <div class="col-lg-7">
              @if (data().html; as html) {
                <div [innerHTML]="html" class="paragraph"></div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</section>
